module.exports = __webpack_public_path__ + "img/Icon-Corr-Pricer.45e799ba.svg";